import { render, staticRenderFns } from "./classTeacherSingle.vue?vue&type=template&id=3486cbbd&scoped=true"
import script from "./classTeacherSingle.vue?vue&type=script&lang=js"
export * from "./classTeacherSingle.vue?vue&type=script&lang=js"
import style0 from "./classTeacherSingle.vue?vue&type=style&index=0&id=3486cbbd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486cbbd",
  null
  
)

export default component.exports